import { FC, PropsWithChildren, useCallback } from 'react';

import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/react';

import {
  InfiniteScrollOnRefresh,
  InfiniteScrollOnScroll,
} from './InfiniteScroll.types';

type IonInfiniteScrollProps = PropsWithChildren<{
  disabled?: boolean;
  onScroll?: () => Promise<unknown>;
  onRefresh?: () => Promise<unknown>;
}>;

export const InfiniteScroll: FC<IonInfiniteScrollProps> = ({
  children,
  onScroll = () => Promise.resolve(),
  onRefresh = () => Promise.resolve(),
  disabled = false,
}) => {
  const handleOnScroll: InfiniteScrollOnScroll = useCallback(
    (e) => {
      onScroll().then(() => e.target.complete());
    },
    [onScroll]
  );

  const handleOnRefresh: InfiniteScrollOnRefresh = useCallback(
    ({ detail: { complete } }) => {
      onRefresh().then(() => complete());
    },
    [onRefresh]
  );

  return (
    <>
      {!!onRefresh && (
        <IonRefresher slot="fixed" onIonRefresh={handleOnRefresh}>
          <IonRefresherContent />
        </IonRefresher>
      )}
      {children}
      {!!onScroll && (
        <IonInfiniteScroll
          threshold="30%"
          disabled={disabled}
          onIonInfinite={handleOnScroll}
        >
          <IonInfiniteScrollContent />
        </IonInfiniteScroll>
      )}
    </>
  );
};
